module.exports = __webpack_public_path__ + "static/img/more-class.250fcf9b.png";